import { selectComponentByWeight } from '../common/Slot/SlotSelectors';

export const selectKebabItems = () =>
  selectComponentByWeight('hosts-index-kebab');



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/components/HostsIndex/Selectors.js